module.exports = __webpack_public_path__ + "607e069b06fd9f7cc446dbd0a64ae1b1.jpg";